// AdminSidebar/adminsidebar.js
import React from 'react';
import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faChartBar, 
    faExclamationCircle, 
    faUsers, 
    faCog 
} from '@fortawesome/free-solid-svg-icons';

const AdminSidebar = ({ activePage, setActivePage }) => {
    const menuItems = [
        { id: 'reports', label: 'Reports', icon: faExclamationCircle },
        { id: 'users', label: 'Users', icon: faUsers },
        { id: 'settings', label: 'Settings', icon: faCog },
        { id: 'home', label: 'Home', icon: faCog },
        //{ id: 'upgrade', label: 'Dev Tools', icon: faCog  }
    ];

    return (
        <Nav className="flex-column bg-dark min-vh-100 p-3">
            <h4 className="mb-4">Admin Panel</h4>
            {menuItems.map(item => (
                <Nav.Link
                    key={item.id}
                    className={`d-flex align-items-center mb-3 ${activePage === item.id ? 'active' : ''}`}
                    onClick={() => setActivePage(item.id)}
                    style={{ cursor: 'pointer' }}
                >
                    <FontAwesomeIcon icon={item.icon} size="lg" className="me-2" />
                    <i className={`fa ${item.icon.iconName} me-2`}></i>
                    {item.label}
                </Nav.Link>
            ))}
        </Nav>
    );
};

export default AdminSidebar;